import React, { useEffect, useState } from "react";
import { Box, Button, Select, Flex } from '@chakra-ui/react'
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetTeamsFunc } from "../Redux/Teams/getTeams";
import { ViewResponsesFunc } from "../Redux/Form/ViewResponses";
import { GetEmpIdFunc } from "../Redux/Teams/getEmpId";
import Response from "../Components/Response";

export const Result = () => {
  const dispatch = useDispatch()
  const userId = useSelector((state) => state.user.userData.userId);
  const getEmpId = useSelector((state) => state.GetEmpId.data)
  const getTeams = useSelector((state) => state.GetTeams.data)
  const Id = useParams()
  const [TeamSeleted, setTeamSeleted] = useState("")
  const [EmpSeleted, setEmpSeleted] = useState("")

  useEffect(() => {
    dispatch(GetTeamsFunc(userId))
  }, [userId])

  const handleTeams = (e) => {
    dispatch(GetEmpIdFunc(userId, e.target.value))
  }

  const handleSubmit = () => {
    dispatch(ViewResponsesFunc(Id.formId, EmpSeleted, userId))
  }

  return (
    <Box p="10px">
      <Flex direction={{ base: "column", md: "row" }} justifyContent="center" alignItems="center" mt="10" gap="14">
        <Select w={{ base: "100%", md: "400px" }} placeholder="Select Team" onChange={handleTeams}>
          {getTeams.map((el, i) => <option key={i} value={el.teamId}>{el.teamName}</option>)}
        </Select>
        <Select w={{ base: "100%", md: "400px" }} placeholder="Select Form" onChange={(e) => setEmpSeleted(e.target.value)}>
          {getEmpId.map((el, i) => <option key={i} value={el.empId}>{el.fullname}</option>)}
        </Select>
        <Button onClick={handleSubmit} colorScheme="blue" w={{ base: "100%", md: "auto" }}>Submit</Button>
      </Flex>
      <Response />
    </Box>
  );
};
